import { render, staticRenderFns } from "./noticedea.vue?vue&type=template&id=a053714a"
import script from "./noticedea.vue?vue&type=script&lang=js"
export * from "./noticedea.vue?vue&type=script&lang=js"
import style0 from "./noticedea.vue?vue&type=style&index=0&id=a053714a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports